module.exports = __webpack_public_path__ + "static/img/logo11.4ffd3800.png";